(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-refine"] && !Shopify.designMode) return;
  try {
    
(function() {
  const initCarousel = (section) => {
    const wrapper = section.querySelector('.featured-products__track-wrapper');
    const item = section.querySelector('.featured-products__item');
    const prev = section.querySelector('.featured-products__arrow.prev');
    const next = section.querySelector('.featured-products__arrow.next');
    if (!wrapper || !item || !prev || !next) return;

    const scrollStep = item.offsetWidth + 24;
    let autoScroll;

    const maxScroll = () => wrapper.scrollWidth - wrapper.clientWidth;

    const moveNext = () => {
      const current = Math.round(wrapper.scrollLeft);
      const maxLeft = Math.round(maxScroll());
      // 🧩 Corrección: evita el espacio en blanco del final
      if (current >= maxLeft - 1) {
        wrapper.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        wrapper.scrollBy({ left: scrollStep, behavior: 'smooth' });
      }
    };

    const movePrev = () => {
      const current = Math.round(wrapper.scrollLeft);
      const maxLeft = Math.round(maxScroll());
      if (current <= 0) {
        wrapper.scrollTo({ left: maxLeft, behavior: 'smooth' });
      } else {
        wrapper.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      }
    };

    // 🔘 Botones
    prev.addEventListener('click', () => {
      movePrev();
      restartAuto();
    });
    next.addEventListener('click', () => {
      moveNext();
      restartAuto();
    });

    // 🔁 Auto-scroll cada 4 segundos
    const startAuto = () => {
      autoScroll = setInterval(moveNext, 4000);
    };
    const stopAuto = () => clearInterval(autoScroll);
    const restartAuto = () => {
      stopAuto();
      startAuto();
    };

    // Pausa con hover o touch
    wrapper.addEventListener('mouseenter', stopAuto);
    wrapper.addEventListener('mouseleave', startAuto);
    wrapper.addEventListener('touchstart', stopAuto);
    wrapper.addEventListener('touchend', startAuto);

    // 🚀 Iniciar
    startAuto();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.featured-products-section').forEach(initCarousel);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initCarousel(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {

  const grid = document.querySelector("#product-grid");
  const loader = document.getElementById("infinite-loader");
  const pagination = document.querySelector(".pagination");

  if (!grid || !loader || !pagination) return;

  // Agrega los filtros y el orden actuales a la URL siguiente
// Agrega los filtros y el orden actuales a la URL siguiente
function mergeParams(url, params) {
  const base = url.split("?")[0];
  const existing = new URLSearchParams(url.split("?")[1] || "");
  const finalParams = new URLSearchParams(params);

  // Mezcla parámetros existentes + filtros activos
  existing.forEach((v, k) => {
    finalParams.set(k, v);
  });

  return base + "?" + finalParams.toString();
}

let currentParams = window.location.search;
let nextPage = pagination.dataset.nextUrl
  ? mergeParams(pagination.dataset.nextUrl, currentParams)
  : null;


  let isLoading = false;

  async function loadNextPage() {
    if (isLoading || !nextPage) return;

    isLoading = true;
    loader.style.opacity = "1";

    try {
      const res = await fetch(nextPage);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newItems = doc.querySelectorAll("#product-grid .grid__item");
      const nextPagination = doc.querySelector(".pagination");

      newItems.forEach((item) => {
        item.style.opacity = "0";
        item.style.transform = "translateY(20px)";
        grid.appendChild(item);

        // Animación suave Refine
        requestAnimationFrame(() => {
          item.style.transition = "opacity 0.6s ease, transform 0.6s ease";
          item.style.opacity = "1";
          item.style.transform = "translateY(0)";
        });
      });

      // Actualiza para próxima página (si existe)
      nextPage = nextPagination 
        ? nextPagination.dataset.nextUrl + currentParams 
        : null;

      if (!nextPage && pagination) {
        pagination.remove();
      }

    } catch (err) {
      console.error("Error cargando productos:", err);
    } finally {
      loader.style.opacity = "0";
      isLoading = false;
    }
  }

  // Observador para cargar antes de llegar al final
  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];

    if (entry.isIntersecting && !isLoading && nextPage) {
      loadNextPage();
    }

  }, {
    root: null,
    rootMargin: "400px",
    threshold: 0
  });

  observer.observe(loader);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-cards-dawn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.scrolling-cards-track').forEach(track => {
    const speed = track.dataset.speed || 70;
    const direction = track.dataset.direction || 'left-right';
    const parent = track.parentElement;

    // 🔁 Clonamos el contenido una sola vez para crear el bucle continuo
    const clone = track.cloneNode(true);
    parent.appendChild(clone);

    // Damos animación fluida
    track.style.animation = `${direction === 'right-left' ? 'infinite-left' : 'infinite-right'} ${speed}s linear infinite`;
    clone.style.animation = track.style.animation;
  });
});

  } catch(e) { console.error(e); }
})();
})();
